import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {ViewModule} from 'app/views/view.module';
import {MailsStatusComponent} from "./mail_status/mail_status.component";
import {MailComponent} from "./mail/mail.component";
import {MailDetailComponent} from "./mail/mail_detail.component";
import {MailerComponent} from "./mailer/mailer.component";
import {MailService} from "./mail.service";
import {MailerReport} from "./mailer/mailer.report";
import {MailBodyModalComponent} from "./mail_status/mail_body.component";
import {RouterModule} from "@angular/router";
import {SendTestComponent} from "./send_test/send_test.component";
import {FilterComponent} from "./mailer/modals/filter.component";

@NgModule({
	imports: [
		ViewModule,
		HttpClientModule,
		RouterModule
	],
	declarations: [
		MailComponent,
		MailDetailComponent,
		MailsStatusComponent,
		MailerComponent,
		MailerReport,
		MailBodyModalComponent,
		SendTestComponent,
		FilterComponent,
	],

	providers: [
		MailService
	],
	entryComponents: [
		MailDetailComponent,
		MailerReport,
		MailBodyModalComponent,
		FilterComponent,
	]
})
export class MailsModule {}
